import { render, staticRenderFns } from "./NormalSearchNav477.vue?vue&type=template&id=12f4a749&scoped=true&"
import script from "./NormalSearchNav477.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav477.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4a749",
  null
  
)

export default component.exports